interface Listeners {
  [event: string]: ((...params: any) => void)[]
}

interface EventBuffer {
  [event: string]: any[][]
}

type AjaxProps = {
  url: string
  timeout: number
}

export default class PubSub {
  private listeners: Listeners = {}
  private buffer: EventBuffer = {}

  public on(event: string, callback: (...params: any) => void) {
    const listeners = this.listeners[event] ?? []
    const buffer = this.buffer[event] ?? []

    listeners.push(callback)

    buffer.forEach((params) => {
      try {
        callback(...params)
      } catch (err) {
        console.error(err)
      }
    })

    this.buffer[event] = []
    this.listeners[event] = listeners
  }

  public trigger(event: string, ...params: any) {
    const listeners = this.listeners[event] ?? []
    const buffer = this.buffer[event] ?? []

    listeners.forEach((callback) => callback(event, ...params))
    if (listeners.length === 0) {
      buffer.push([event, ...params])
    }
    this.buffer[event] = buffer
  }

  public off(
    event: string,
    callbackToRemove: (event: string, ...params: any) => void
  ) {
    const listeners = this.listeners[event] ?? []

    this.listeners[event] = listeners.filter(
      (callback) => callback !== callbackToRemove
    )
  }

  public ajax({ url, timeout = 10 * 1000 }: AjaxProps) {
    const retry = () => {
      return new Promise((resolve, reject) => {
        const fetchTimeout = setTimeout(() => {
          reject({ error: 'timeout' })
        }, timeout)

        window
          .fetch(url)
          .then((res) => {
            clearTimeout(fetchTimeout)

            return res
          })
          .then((res) => res.json())
          .then((res) => resolve(res))
      })
    }

    return {
      retry,
    }
  }
}
